import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { whatsappLink } from "@/lib/api";
import { findCity, findNlArea } from "@/lib/riviera";

const HIDE_ON = ["/book", "/fr/book", "/fr/inquiry", "/quote"];

const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.43 9.43 0 0 1-4.8-1.31l-.35-.21-3.57.94.95-3.48-.23-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.24-9.44 9.45-9.44a9.4 9.4 0 0 1 6.68 2.77 9.38 9.38 0 0 1 2.76 6.68c0 5.21-4.24 9.44-9.44 9.44zm8.04-17.48A11.3 11.3 0 0 0 12.04.7C5.77.7.67 5.8.67 12.06c0 2 .52 3.96 1.52 5.68L.57 23.7l6.1-1.6a11.33 11.33 0 0 0 5.37 1.37h.01c6.26 0 11.36-5.1 11.36-11.36 0-3.03-1.18-5.89-3.33-8.03z" />
  </svg>
);

const waMessage = (t, path) => {
  const fr = path === "/fr" || path.startsWith("/fr/");
  const seg = path.split("/")[2];
  const city = fr ? findCity(seg)?.name : path.startsWith("/service-areas/") ? findNlArea(seg)?.city : null;
  return t(`wa.${fr ? "fr" : "nl"}${city ? "_city" : ""}`, { city });
};

export default function StickyWhatsApp() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return null;
  return (
    <a
      href={whatsappLink(waMessage(t, pathname))}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp"
      aria-label={t("common.whatsapp_us")}
      title={t("common.whatsapp_us")}
      className="group fixed top-1/2 -translate-y-1/2 right-3 sm:right-5 z-40 inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#1ebd5b] text-white shadow-lg shadow-black/15 ring-2 ring-white transition-[transform,background-color] hover:scale-105"
      style={{ marginRight: "env(safe-area-inset-right)" }}
    >
      <WaIcon />
      <span className="pointer-events-none absolute right-full mr-3 hidden lg:block whitespace-nowrap rounded-full bg-[#0F172A] text-white text-xs font-semibold px-3 py-1.5 opacity-0 translate-x-1 transition-[opacity,transform] group-hover:opacity-100 group-hover:translate-x-0">
        {t("common.whatsapp_us")}
      </span>
    </a>
  );
}
